export const AFTER_QUERY_SUGGEST_LAYER = 'search-box-aqsl'
export const ALT_SERP_IT = 'new-serp-layout-it'
export const RELEASE_SWITCH_TOGGLE = 'release-switch'
export const RELEASE_TOGGLE_SAE_ONLY = 'sae-only'
export const RELEASE_TOGGLE_MARKETPLACE = 'marketplace'
export const RELEASE_TOGGLE_ERX = 'erx'
export const RELEASE_TOGGLE_ERX_ANNOUNCEMENT = 'erx-announcement'
export const PRE_QUERY_SUGGEST_NAME = 'search-box-pqsl'
export const SERP_FILTERING = 'serp-filtering'
export const XSELL_NEW_LAYOUT = 'xsell-new-layout'
export const HEALTHY_DEALS_XSELL = 'h-deals-xsell'
export const AA_TEST_FR = 'aa-test-fr'
export const PDP_CSW_POSITION = 'pdp-csw-position'
export const HOMEPAGE_SERVICES = 'homepage-services'
export const PDP_CSW_NEW_ALGO = 'pdp-csw-new-algo'
export const PDP_STICKY_XSELL = 'pdp-sticky-xsell'
export const PDP_CSW_MOBILE = 'pdp-csw-mobile'
